import { jsx as _jsx } from "react/jsx-runtime";
import { Html } from '@react-three/drei';
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onSetMultipleComponentProps_Cn_Doc } from '../../../store/actions';
import { buttonTitleShouldBeUpdated, textTitleShouldBeUpdated } from '../../../utils';
import TextArea from '../../dom/Inputs/TextArea/TextArea';
import { IComponentType } from '../r3f-components/component-data-structure';
import CSS from './FloatingInput.scss';
const FloatingInput = ({ position, text, onBlur, onUnmount }) => {
    const dispatch = useDispatch();
    const selectedEntityIds = useSelector((state) => state.userReducer.selectedEntityIds);
    const componentsById = useSelector((state) => state.contentReducer.contentDoc.componentsById);
    const currentTitle = useSelector((state) => state.contentReducer.contentDoc.componentsById[selectedEntityIds[0]].title);
    const isButton = componentsById[selectedEntityIds[0]].type === IComponentType.Button;
    const wrapperRef = useRef(null);
    const timerRef = useRef(null);
    const [margins, setMargins] = useState([0, 0]);
    useEffect(() => {
        return () => {
            if (timerRef.current)
                window.clearTimeout(timerRef?.current);
            onUnmount?.();
        };
    }, []);
    const onBlurHandler = (e) => {
        if (onBlur)
            onBlur(e);
    };
    const onMountHandler = (textAreaRef) => {
        if (!textAreaRef?.current)
            return;
        setMargins([textAreaRef.current.offsetWidth / 2, textAreaRef.current.offsetHeight / 2]);
        timerRef.current = window.setTimeout(() => textAreaRef?.current?.focus?.(), 150);
        if (!ResizeObserver)
            return;
        function outputsize() {
            if (!textAreaRef?.current)
                return;
            setMargins([textAreaRef.current.offsetWidth / 2, textAreaRef.current.offsetHeight / 2]);
        }
        new ResizeObserver(outputsize).observe(textAreaRef.current);
    };
    return (_jsx(Html, { position: position, ref: wrapperRef, children: _jsx(TextArea, { value: text, className: CSS.TextInput, style: {
                marginLeft: `-${margins[0]}px`,
                marginTop: `-${margins[1]}px`,
                opacity: !!margins[0] && !!margins[1] ? 1 : 0,
            }, focused: true, stopPropagation: true, onChange: (e) => {
                const multiplePropsCnDocPayload = {
                    id: selectedEntityIds[0],
                    text: e.target.value,
                };
                if (isButton) {
                    // Set the title for this button if required
                    if (buttonTitleShouldBeUpdated(currentTitle, e.target.value)) {
                        multiplePropsCnDocPayload.title = e.target.value;
                    }
                }
                else {
                    // Is text - set the title for this button if required
                    if (textTitleShouldBeUpdated(currentTitle, e.target.value)) {
                        multiplePropsCnDocPayload.title = e.target.value;
                    }
                }
                dispatch(onSetMultipleComponentProps_Cn_Doc([multiplePropsCnDocPayload]));
            }, onBlur: onBlurHandler, onMount: onMountHandler }) }));
};
export default React.memo(FloatingInput);
